import { FactoryProvider, InjectionToken } from '@angular/core';

declare global {
  interface Window {
    eid: any;
  }
}

export const EIDSDK = new InjectionToken<any>('EidSdkToken');

export function eidSdkFactory(): any {
  return window.eid;
}

export const EIDSDK_PROVIDER: FactoryProvider = {
  provide: EIDSDK,
  useFactory: eidSdkFactory
};
